// Lib
import React, { ReactElement } from 'react';

// Components
import MobileTextStyleSheetContent from './MobileTextStyleSheetContent';
import MobileTextStyleRichTextSheet from './MobileTextStyleRichTextSheet';

// Types
import type { MobileTextStyleRichTextSheetProps } from './MobileTextStyleRichTextSheet';

const MobileTextStyleRichTextTool = (props: MobileTextStyleRichTextSheetProps): ReactElement => {
    return <MobileTextStyleRichTextSheet {...props} SheetContentComponent={MobileTextStyleSheetContent} />;
};

export default MobileTextStyleRichTextTool;
